/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Tags from "./Tags";
import GetItem from "../../../helpers/dataProviders/getItem";
import parseAppKey from "../../../helpers/routeHelpers/parseAppKey";

class PostTagPicker extends Component {
	constructor(props) {
		super(props);
		this.state = {
			values: [],
		};
		this.appKey = parseAppKey();
	}

	componentDidMount() {
		this.getValues();
	}

	getValues = () => {
		GetItem(`/apps/${this.appKey}/posts`).then(data => {
			let values = [];
			let tags = {};
			data.data.forEach(item => {
				item.tags.forEach(tag => {
					tags[tag] = tag;
				});
			});
			Object.keys(tags).forEach(tag => {
				values.push({
					id: tag,
					label: tag,
				});
			});

			this.setState({ values });
		});
	};

	render() {
		const { values } = this.state;
		return (
			<div className="picker-input">
				{values && (
					<div>
						<Tags
							{...this.props}
							tagInstructions="Type to Search"
							dataObjects={values}
							dataObjectKey="id"
							dataObjectLabel="label"
							minQueryLength={1}
						/>
						{values.length === 0 && (
							<div className="alert alert-warning">{"No Tags Available. Add Posts with tags first"}</div>
						)}
					</div>
				)}
			</div>
		);
	}
}

PostTagPicker.propTypes = {
	fieldState: PropTypes.object,
	fieldApi: PropTypes.object,
	placeholder: PropTypes.string,
	tagInstructions: PropTypes.string,
	apps: PropTypes.array,
	isRequired: PropTypes.bool,
};

const mapStateToProps = state => ({
	apps: state.apps.apps,
});

export default connect(mapStateToProps)(PostTagPicker);
